"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _interfaces = require("../text/interfaces");
var _link = require("../link");
var _utils = require("../utils");
var _constants = require("./constants");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MessageBannerLink = _link.Link.withComponent('a', process.env.NODE_ENV === "production" ? {
  target: "e1mfx37y0"
} : {
  target: "e1mfx37y0",
  label: "MessageBannerLink"
});
MessageBannerLink.defaultProps = {
  ..._link.Link.defaultProps,
  color: _constants.TEXT_COLOR,
  variant: _interfaces.TextVariant.BodyMD,
  fontWeight: 'medium'
};
const MessageBannerLinkWithDocs = (0, _stencilReactDesc.describe)(MessageBannerLink).description('Link component styled to fit in a message banner.');
MessageBannerLinkWithDocs.propTypes = {
  ..._link.Link.describedPropTypes
};

// withComponent has to be redefined because of Link's wrapper-like internal structure
MessageBannerLinkWithDocs.withComponent = tag => {
  const LinkWithComponent = _link.Link.withComponent(tag, process.env.NODE_ENV === "production" ? {
    target: "e1mfx37y1"
  } : {
    target: "e1mfx37y1",
    label: "LinkWithComponent"
  });
  LinkWithComponent.defaultProps = {
    ...MessageBannerLink.defaultProps
  };
  return /*#__PURE__*/(0, _react.forwardRef)((props, ref) => (0, _react2.jsx)(LinkWithComponent, (0, _extends2.default)({}, props, {
    ref: ref
  })));
};
const MessageBannerLinkWithTestAttributes = (0, _utils.withTestAttributes)({
  component: 'MessageBannerLink'
})(MessageBannerLink);
MessageBannerLinkWithTestAttributes.displayName = 'MessageBannerLink';
var _default = exports.default = MessageBannerLinkWithTestAttributes;